import i18next from 'i18next';

i18next.addResources('es_CL', 'NPSFormSuccess', {
  title: '¡GRACIAS POR TU TIEMPO!',
  subtitle: 'Esperamos verte pronto.',
  description: 'Esta encuesta fue contestada previamente.'
});
